import { render, staticRenderFns } from "./DashItem.vue?vue&type=template&id=7027a67f"
import script from "./DashItem.vue?vue&type=script&lang=js"
export * from "./DashItem.vue?vue&type=script&lang=js"
import style0 from "./DashItem.vue?vue&type=style&index=0&id=7027a67f&prod&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports